import { FC } from 'react'
import Select from 'react-select'
import styles from '../EditClaimCardMainInformation.module.css'
import { useMediaQuery } from 'react-responsive'

interface PlaceInformationSectionProps {
  values: any
  platformNames: { id: number; name: string }[]
  platformId: number
  places: any[]
  setFieldValue: (field: string, value: any) => void
  handleBlur: (e: any) => void
  setPlatformId: (id: number) => void
  setPlatformSize: (size: number | number[]) => void
}

export const PlaceInformationSection: FC<PlaceInformationSectionProps> = ({
  values,
  platformNames,
  platformId,
  places,
  setFieldValue,
  handleBlur,
  setPlatformId,
  setPlatformSize,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Информация о месте</div>
      <div className={styles.sectionContent}>
        <div className={styles.platformNameBlock}>
          <div className={styles.leftBlock}>Зал</div>
          <div className={styles.rightBlock}>
            {platformNames.length > 0 ? (
              <Select
                name='platformName'
                className={styles.selectInput}
                classNamePrefix='react-select'
                options={platformNames?.map((platform) => ({
                  value: platform.id.toString(),
                  label: platform.name,
                  id: platform.id,
                }))}
                value={
                  values.platformId || platformId
                    ? {
                        value: String(values.platformId || platformId),
                        label:
                          platformNames?.find(
                            (p) => p.id.toString() === String(values.platformId || platformId),
                          )?.name ||
                          values.platformName ||
                          '',
                      }
                    : null
                }
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    const selectedPlatformId = selectedOption.value
                    setFieldValue('platformId', selectedPlatformId)
                    setFieldValue('platformName', selectedOption.label)
                    setPlatformId(Number(selectedPlatformId))

                    const selectedPlatform = places.find(
                      (platform) => platform.id === Number(selectedPlatformId),
                    )

                    if (selectedPlatform) {
                      setPlatformSize(selectedPlatform.size)
                    }
                  } else {
                    setFieldValue('platformId', '')
                    setFieldValue('platformName', '')
                    setPlatformId(-1)
                    setPlatformSize(-1)
                  }
                }}
                onBlur={handleBlur}
                styles={{
                  singleValue: (provided) => ({
                    ...provided,
                    color: values.platformId ? 'black' : provided.color,
                  }),
                  control: (provided) => ({
                    ...provided,
                    border: 'none',
                    boxShadow: 'none',
                    minHeight: 'auto',
                    backgroundColor: 'transparent',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    right: 0,
                    overflow: 'auto',
                    height: '150px',
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: '150px',
                    overflowY: 'auto',
                  }),
                  input: (provided) => ({
                    ...provided,
                    margin: 0,
                    padding: 0,
                    height: isMobile ? 44 : 20,
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    padding: 0,
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    padding: 0,
                  }),
                  clearIndicator: (provided) => ({
                    ...provided,
                    padding: 0,
                  }),
                  indicatorSeparator: () => ({
                    display: 'none',
                  }),
                }}
                isClearable
                placeholder='Выберите платформу'
                noOptionsMessage={() => 'Нет доступных платформ'}
              />
            ) : (
              <div className={styles.companyBlock}>{values.platformName}</div>
            )}
          </div>
        </div>
        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Город</div>
          <div className={styles.rightBlock}>
            <div className={styles.companyBlock}>{values.city}</div>
          </div>
        </div>
        <div className={styles.clientBlock}>
          <div className={styles.leftBlock}>Менеджер отеля</div>
          <div className={styles.rightBlock}>
            <div className={styles.companyBlock}>{values.owner}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
